<template>
    <modal
        :saveAction="save"
        :title="$t(title)"
        :id="id"
        :deleteAction="exam._id ? deleteAction : false"
        :actionButtons="!hideForm"
        size="full"
        :closeButton="hideForm"
        @shown="shown()"
        @hidden="hidden()"
		:actionPrint="!!exam._id"
		:print="print"
    >
        <div class="row align-items-center mb-2">
            <div class="col-auto">
                <label class="mb-0">{{$t('Template')}}</label>
            </div>
            <div class="col-auto">
                <select-searchable @pasteFromTemplate="appendTemplate"></select-searchable>
            </div>
            <div class="col-12 mt-3">
                <editor class="document-editor-height-exam-desc" v-model="content" />
            </div>
        </div>
		<print-exam-description id="PrintExamDescription"></print-exam-description>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'
import Editor from '@/components/Editor.vue';
import SelectSearchable from "@/components/Elements/SelectSearchable";
import PrintExamDescription from './ExamDescriptionPrintModal.vue';

export default {
    name: 'exam-description-form-modal',
    props: ['id', 'saveAction', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,
        Editor,
        SelectSearchable,
		PrintExamDescription
    },
    data() {
        return {
            content: null,
            loading: false,
            hideForm: false,
            title: 'Add Description',
            exam: {},
        }
    },

    mounted() {
        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
        })
        //return this.find({ query: {} }).data;
    },
    methods: {
        ...mapActions('exam', ['find', 'create', 'patch', 'remove']),

        save() {
            let exam = {
                description: this.content,
                customerId: this.$route.params.id
            }
            let promise, successMessage;
            if (this.exam._id) {
                promise = this.patch([this.exam._id, exam]);
                successMessage = this.$t('Item has been updated');
            } else {
                promise = this.create(exam);
                successMessage = this.$t('Item has been created');
            }
            promise.then(result => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });
        },
        deleteAction() {
            this.remove(this.exam._id).then(result => {
                this.$toasted.global.success({
                    message: this.$('Item has been removed')
                });
            });
        },
        shown() {
            const { Exam } = this.$FeathersVuex;
            let data = Exam.getFromStore('temp');
            if (data) {
                delete data._id;
                this.exam = data.exam;
                this.content = this.exam.description;
                new Exam({
                    model: {},
                    _id: 'temp'
                });
            }
        },
        hidden() {
            this.exam = {};
        },
        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        },
        appendTemplate(content) {
            this.content = content;
        },
		print() {
			let exam = this.exam;
			let examItem = {
				exam,
				_id: 'temp'
			};
			const { Exam } = this.$FeathersVuex;
			new Exam(examItem);

			this.openModal({
				id: 'PrintExamDescription',
				data: exam,
			})
		}
    },

}
</script>
<style lang="scss">
.document-editor-height-exam-desc {
    height: calc(var(--calculated-vh, 1vh) * 100 - 250px);
}
</style>
